<template>
  <div id="app" class="d-flex" :class="[this.$route.meta.baseClass || '', layout]" :data-refera-version="appVersion"
    :data-build-version="buildVersion" :data-refera-environment="appEnvironment">
    <div class="initial-loader" v-if="isInitialLoadingRoute"></div>
    <component v-else :is="layout">
      <router-view />
    </component>
    <!-- 👇 ONLY in non-production -->
    <template v-if="isBugReportAvailable">
      <button class="bug-fab" @click="showBugModal = true">
        🐛 Bug
      </button>

      <BugReportModal :visible="showBugModal" endpoint="/api/bug-reports/" :extra-context="bugContext"
        @close="showBugModal = false" @submitted="showBugModal = false" />
    </template>
  </div>
</template>
<script>
window.RevampConfig = Object.freeze({
  version: process.env.VUE_APP_VERSION,
  base_url: process.env.VUE_APP_API_BASE_URL,
  api: process.env.VUE_APP_API_BASE_URL + '/api',
})
const observer = new IntersectionObserver(
  (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const img = entry.target
        img.src = img.dataset.src
        img.classList.add('lazy-loaded')
        observer.unobserve(img)
      }
    })
  },
  {
    rootMargin: '0px',
    threshold: 0.1,
  }
)
import BugReportModal from '@/components/shared/BugReportModal.vue'
export default {
  name: 'App',
  components: {
    BugReportModal,
  },
  data() {
    return {
      appVersion: process.env.VUE_APP_VERSION,
      buildVersion: process.env.VUE_APP_BUILD_VERSION || 'LOCAL_V0',
      appEnvironment: process.env.VUE_APP_ENV,
      mutationObserver: null,
      showBugModal: false,
    }
  },
  created() {
    this.$store.dispatch('state/load')
    window.addEventListener('beforeunload', this.handleBeforeUnload)
  },
  mounted() {
    this.$nextTick(() => {
      document.querySelectorAll('[data-src]').forEach((el) => observer.observe(el))
    })

    this.mutationObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== Node.ELEMENT_NODE) return
          if (node.dataset?.src) observer.observe(node)
          node.querySelectorAll('[data-src]').forEach((el) => observer.observe(el))
        })
      })
    })

    this.mutationObserver.observe(this.$el, { childList: true, subtree: true })
  },
  computed: {
    layout() {
      return (this.$route.meta.layout || 'base') + '-layout'
    },
    isInitialLoadingRoute() {
      const { name, path, matched } = this.$route
      return path === '/' && (!matched || !matched.length) && !name
    }, 
    isNonProduction() {
      return ['local', 'dev', 'staging'].includes(this.appEnvironment)
    },
    isBugReportAvailable() {
      return this.isNonProduction && false
    },
    bugContext() {
      const user = this.$store?.state?.auth?.user || null

      return {
        routeName: this.$route?.name,
        fullPath: this.$route?.fullPath,
        params: this.$route?.params,
        query: this.$route?.query,
        userId: user?.id || null,
        practiceId: user?.practice_id || null,
        appVersion: this.appVersion,
        buildVersion: this.buildVersion,
        environment: this.appEnvironment,
      }
    }
  },
  methods: {
    handleBeforeUnload() {
      if (this.$store.state.settings.versionCheckIntervalId)
        clearInterval(this.$store.state.settings.versionCheckIntervalId)
    },
  },
  beforeDestroy() {
    this.mutationObserver?.disconnect()
    this.mutationObserver = null
    window.removeEventListener('beforeunload', this.handleBeforeUnload)
  },
}
</script>
<style lang="scss">
@import '../node_modules/bootstrap/scss/bootstrap.scss';
@import './styles/global.scss';
</style>
<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app.base-layout .container-fluid {
  max-width: 1440px;
}

.bug-fab {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 9998;
  border: 0;
  border-radius: 999px;
  padding: 10px 14px;
  background: #222;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
}
</style>
